<template>
  <div>
    <b-modal
      id="detail-employee-movement-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Pengajuan Mutasi Karyawan"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Karyawan</span></th>
                <td>{{ result.employee ? result.employee.fullName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Alasan Dipindah</span></th>
                <td>{{ result.note }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Cabang</span></th>
                <td>{{ result.branch ? result.branch.branchName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Departement</span></th>
                <td>{{ result.jobTitle ? result.jobTitle.department ? result.jobTitle.department.departmentName : '-' : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Posisi</span></th>
                <td>{{ result.jobTitle ? result.jobTitle.positionName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Band</span></th>
                <td>{{ result.band ? result.band.bandName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Grade</span></th>
                <td>{{ result.grade ? result.grade.gradeName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Status</span></th>
                <td>{{ result.statusApproval }}</td>
              </tr>
            </tbody>
          </table>

         

        </b-col>
      </b-row>

      <span v-if="result.statusApproval == 'waiting for approval'">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" :disabled="isLoadingApprove" @click="approve()">
          <b-spinner class="mr-1" small variant="light" v-if="isLoadingApprove" />
          Approve
        </b-button>
        <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="danger"
        class="mr-2"
        :disabled="isLoadingReject"
        @click="reject()"
      >
        <b-spinner class="mr-1" small variant="light" v-if="isLoadingReject" />
        Reject
      </b-button>
      </span>

      

      

    </b-modal>
  </div>
</template>

<script>
  import Ripple from "vue-ripple-directive";
import { BCol, BAvatar, BRow, BButton, BSpinner } from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
  data() {
    return {
      isLoadingApprove: false,
      isLoadingReject: false,
    }
  },
  methods: {
    approve() {
      const form = { 
        approveType: "APPROVE",
        id: this.result.id,
      };
      this.isLoadingApprove = true;

      this.$http
        .post(`/employee-activity/employee-movement/approveOrReject`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            successNotification(this, "Success", "Pengajuan mutasi karyawan berhasil di setujui!");
            window.location.reload();
          }
          
          this.isLoadingApprove = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);
          this.isLoadingApprove = false;
        });


    },
    reject() {
      const form = { 
        approveType: "REJECT",
        id: this.result.id,
      };
      this.isLoadingReject = true;

      this.$http
        .post(`/employee-activity/employee-attendance/approveOrReject`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            successNotification(this, "Success", "Pengajuan mutasi karyawan berhasil di tolak!");
            window.location.reload();
          }
          
          this.isLoadingReject = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);
          this.isLoadingReject = false;
        });


    },
  }
};
</script>
